import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../shared/models/user.model';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css'],
    standalone: false
})
export class UserListComponent implements OnInit {
	 @Input() allUsers: User[] = [];
  constructor() { }

  ngOnInit() {
  }

}
